import React, { Fragment } from 'react';

import PlaceholderPlugin from '../PlaceholderPlugin';

const PlaceholderList = () => (
  <Fragment>
    <PlaceholderPlugin />
    <PlaceholderPlugin />
    <PlaceholderPlugin />
    <PlaceholderPlugin />
    <PlaceholderPlugin />
    <PlaceholderPlugin />
    <PlaceholderPlugin />
  </Fragment>
);

export default PlaceholderList;
